var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminderRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9992 30C17.0453 30 18.8073 28.9137 19.5805 27.3633H10.418C11.1911 28.9137 12.9532 30 14.9992 30Z",
    fill: "#990000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 14.5232V12.5977C25.3333 8.50652 22.2393 5.039 18 3.90645V2.63672C18 1.18283 16.6542 0 15 0C13.3458 0 12 1.18283 12 2.63672V3.90645C7.76072 5.039 4.66673 8.50646 4.66673 12.5977V14.5232C4.66673 18.1168 3.1082 21.5244 0.278277 24.1182C0.00094458 24.3724 -0.0769886 24.7475 0.0802109 25.0714C0.23741 25.3953 0.599409 25.6055 1.00007 25.6055H29C29.4007 25.6055 29.7626 25.3953 29.9198 25.0714C30.077 24.7475 29.9991 24.3724 29.7218 24.1182C26.8919 21.5244 25.3333 18.1168 25.3333 14.5232ZM16 3.55828C15.6709 3.53039 15.3374 3.51562 15 3.51562C14.6627 3.51562 14.3292 3.53039 14 3.55828V2.63672C14 2.15209 14.4486 1.75781 15 1.75781C15.5514 1.75781 16 2.15209 16 2.63672V3.55828Z",
    fill: "#990000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0009 12.5973C28.0009 13.0826 28.4486 13.4762 29.0009 13.4762C29.5531 13.4762 30.0009 13.0826 30.0009 12.5973C30.0009 9.07577 28.4406 5.76505 25.6075 3.27499C25.217 2.9318 24.5838 2.93175 24.1933 3.27499C23.8028 3.61823 23.8028 4.17469 24.1933 4.51794C26.6487 6.676 28.0009 9.54528 28.0009 12.5973Z",
    fill: "#990000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999997 13.4761C1.55226 13.4761 1.99999 13.0826 1.99999 12.5972C1.99999 9.5453 3.35226 6.67603 5.80758 4.51796C6.19811 4.17472 6.19811 3.61825 5.80758 3.27501C5.41712 2.93177 4.78392 2.93177 4.39339 3.27501C1.56026 5.76507 0 9.07573 0 12.5972C0 13.0826 0.447732 13.4761 0.999997 13.4761Z",
    fill: "#990000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderRedIcon);
export default __webpack_public_path__ + "static/media/reminderRedIcon.a31d7285bf55ecc08e2a5f5a8128a9fb.svg";
export { ForwardRef as ReactComponent };